import type { Theme } from '@mui/material/styles';

import { cssVar } from '@mfw/common';

type FillFamily =
  | 'accent'
  | 'error'
  | 'info'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning';

/**
 * A family's `main` FILL as the live CSS var, for a component override that
 * paints one (a hover or focus that keeps the fill, `fill-hover.spec.ts`).
 *
 * Not `theme.palette[family].main`: the overrides receive the JS theme, whose
 * palette is a snapshot of the SAVED brand, while MUI's own fills under
 * `CssVarsProvider` read the vars. The rebrand editor previews a draft by
 * rewriting those vars on `:root` without rebuilding the theme, so a literal
 * hover showed the saved brand under the draft's ink (1.90:1). `info` has no
 * catalog var — it is static everywhere — so it alone is its literal.
 */
export const fillMain = (theme: Theme, family: FillFamily) =>
  family === 'info' ? theme.palette.info.main : cssVar[family].main;
